module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Status")]), _vm._v(" "), (_vm.isLoading) ? _c('loader', {
    staticClass: "col-sm-4 mt-4"
  }) : _c('div', {
    staticClass: "col-sm-4 mt-4"
  }, [_c('button', {
    staticClass: "btn w-100 blue widest btnPill",
    class: {
      'opacity-30': _vm.getSelectedEvent.status == _vm.statusId('Canceled')
    },
    on: {
      "click": _vm.setEventActive
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('button', {
    staticClass: "btn w-100 action widest btnPill",
    class: {
      'opacity-30': _vm.getSelectedEvent.status == _vm.statusId('Active')
    },
    on: {
      "click": _vm.setEventcanceled
    }
  }, [_vm._v("Canceled")])]), _vm._v(" "), (_vm.getSelectedEvent.status == _vm.statusId('Canceled')) ? _c('div', {
    staticClass: "col-sm-10 mt-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n            Cancellation description\n            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.statusMessage),
      expression: "getSelectedEvent.statusMessage"
    }],
    staticClass: "bg-lighter w-100 mt-1",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.getSelectedEvent.statusMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent, "statusMessage", $event.target.value)
      }
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-64a1e870", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a1e870"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaStatus.vue
// module id = 929
// module chunks = 0